@if (componentData$ | async; as data) {
  <div [innerHTML]="data.content"></div>
}
